export default __webpack_public_path__ + "static/media/gta.b8ba43ad.jpg";